import { render } from "./assignLeads.vue?vue&type=template&id=35c6c0f7&scoped=true"
import script from "./assignLeads.vue?vue&type=script&lang=js"
export * from "./assignLeads.vue?vue&type=script&lang=js"

import "./assignLeads.vue?vue&type=style&index=0&id=35c6c0f7&scoped=true&lang=css"
import "./assignLeads.vue?vue&type=style&index=1&id=35c6c0f7&lang=css"
script.render = render
script.__scopeId = "data-v-35c6c0f7"

export default script